import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';
import Icon from 'components/icon';
import Accordion from 'components/accordion';
import { formatDate } from 'utils';

import AppReviewComment from './comment';
import AppReviewCommentAuthor from './comment-author';
import { getCommentPreview } from './utils';

// Modifiers stay namespaced: a bare `.dot` or `.check` collides with the
// global rules the editor and form stylesheets ship
const CHECK_MARKER = (
  <span className="review-comments--marker review-comments--marker-check">
    <Icon fa="check" />
  </span>
);
const DOT_MARKER = (
  <span className="review-comments--marker review-comments--marker-dot" />
);

export default class AppReviewPreviousVersions extends React.PureComponent {
  static propTypes = {
    groups: pt.array.isRequired,
    closedCount: pt.number.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = { isOpen: true, expandedThreadIds: [] };
  }

  onToggleSection = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  onToggleThread = (event) => {
    const { id } = event.currentTarget.dataset;
    const { expandedThreadIds } = this.state;

    this.setState({
      expandedThreadIds: expandedThreadIds.includes(id)
        ? expandedThreadIds.filter((threadId) => threadId !== id)
        : [...expandedThreadIds, id],
    });
  };

  renderThreadSummary(thread) {
    const { user, comment, replies } = thread;
    const lastActivity = replies[replies.length - 1] || thread;

    return (
      <div className="review-comments--previous--summary">
        <span className="review-comments--previous--line">
          <AppReviewCommentAuthor user={user} />
          <span className="review-comments--previous--preview">
            &ldquo;{getCommentPreview(comment)}&rdquo;
          </span>
        </span>
        <span className="review-comments--previous--meta">
          Review closed &bull; {formatDate(lastActivity.date_created, 'ago')}
        </span>
      </div>
    );
  }

  renderReply = (reply) => {
    return (
      <div key={reply.id} className="review-comments--previous--message">
        {DOT_MARKER}
        <AppReviewComment comment={reply} />
      </div>
    );
  };

  renderThread = (thread) => {
    const isExpanded = this.state.expandedThreadIds.includes(thread.id);

    return (
      <div
        key={thread.id}
        className={cx('review-comments--previous--thread', {
          'review-comments--previous--thread-expanded': isExpanded,
        })}
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div
          className="review-comments--previous--message review-comments--previous--message-top"
          data-id={thread.id}
          onClick={this.onToggleThread}
        >
          {CHECK_MARKER}
          {isExpanded ? (
            <AppReviewComment comment={thread} />
          ) : (
            this.renderThreadSummary(thread)
          )}
        </div>
        {isExpanded && thread.replies.map(this.renderReply)}
      </div>
    );
  };

  renderGroup = ({ version, threads }) => {
    return (
      <div
        key={version || 'unversioned'}
        className="review-comments--previous--group"
      >
        {version && (
          <div className="review-comments--previous--version">v{version}</div>
        )}
        <div className="review-comments--previous--threads">
          {threads.map(this.renderThread)}
        </div>
      </div>
    );
  };

  render() {
    const { groups, closedCount } = this.props;

    return (
      <Accordion
        className="review-comments--previous"
        arrowPosition="left"
        isOpen={this.state.isOpen}
        label={`Previous versions · ${closedCount} closed`}
        onClickLabel={this.onToggleSection}
        onClickArrow={this.onToggleSection}
      >
        {groups.map(this.renderGroup)}
      </Accordion>
    );
  }
}
